import React from 'react';
import { connect } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContentWrapper from './SnackbarContentWrapper';
import { closeSnackbar } from '../../actions';
import {
  closeSnackbarType,
  messageType,
  autoHideDurationType
} from '../../types';

const ErrorSnackbar = props => (
  <Snackbar
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left'
    }}
    open
    autoHideDuration={props.autoHideDuration || 3000}
    onClose={props.closeSnackbar}
  >
    <SnackbarContentWrapper
      onClose={props.closeSnackbar}
      variant="error"
      message={props.message}
    />
  </Snackbar>
);

ErrorSnackbar.propTypes = {
  closeSnackbar: closeSnackbarType.isRequired,
  message: messageType.isRequired,
  autoHideDuration: autoHideDurationType
};

ErrorSnackbar.defaultProps = {
  autoHideDuration: null
};

const actions = { closeSnackbar };

export default connect(null, actions)(ErrorSnackbar);
